import script from "./SandBoxEstimateScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SandBoxEstimateScreen.vue?vue&type=script&setup=true&lang=js"

import "./SandBoxEstimateScreen.vue?vue&type=style&index=0&id=2217a3ee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2217a3ee"]])

export default __exports__